import React from 'react'
import ProfileContainer from 'containers/panel/reseller/profile-container'
const ProfilePage = () => {
  return (
    <ProfileContainer/>
  )
}

export default ProfilePage